import { graphql } from "@/lib/gql/__generated__";

export const VoucherDelete_TopPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherDelete_TopPage($hotelID: ID!, $voucherID: ID!) {
		voucherDelete(hotelID: $hotelID, voucherID: $voucherID) {
			userErrors
			message
		}
	}
`);
